<template>
	<div class="dt-sy" style="padding-top: 10px;">
		
		<div style="margin-top: 40px;margin-left: 40px;">
			<div style="font-size: 36px;font-weight: 700;letter-spacing: 3px;">欢迎登录</div>
			<div style="font-size: 18px;margin-top: 10px;font-weight: 600;letter-spacing: 1px;">WELCOME LANDING</div>
		</div>

	</div>

</template>
<script>
	import zh_CN from 'ant-design-vue/lib/locale-provider/zh_CN';
	export default {
		data() {
			return {
				staff: {
					staffAccount: window.sessionStorage.getItem('staffAccount')
				},

			};
		},
		methods: {
			

		},
		mounted() {
		
		},
		created() {

		}
	};
</script>

<style lang="less">
	.dt-sy{
		background-image: url(../assets/images/sybj.png);
		background-size: cover;
		min-height: 100%;
	}
</style>
